import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5f82f895&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=5f82f895&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f82f895",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f82f895')) {
      api.createRecord('5f82f895', component.options)
    } else {
      api.reload('5f82f895', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=5f82f895&scoped=true", function () {
      api.rerender('5f82f895', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/integral/goodsManage/index.vue"
export default component.exports